import TenantFeaturesPage from './TenantFeaturesPage';
import TenantPricingPage from './TenantPricingPage';
import TenantCustomersPage from './TenantCustomersPage';
import TenantAboutPage from './TenantAboutPage';
import ProseFallback from './ProseFallback';
import type { HomepageSection } from './helpers';

interface TenantMarketingLayoutProps {
  /** `pages.slug`: features | pricing | customers | about. */
  slug: string;
  page: { title?: string; content?: string };
  sections?: HomepageSection[];
  siteName: string;
}

/**
 * Picks the structured marketing layout for a wizard-generated tenant page.
 * Each layout reuses the platform design system (MeshHero / cards / CTA band)
 * and degrades to styled prose when the content can't be structured.
 */
export default function TenantMarketingLayout({ slug, page, sections, siteName }: TenantMarketingLayoutProps) {
  switch (slug) {
    case 'features':
      return <TenantFeaturesPage page={page} sections={sections} siteName={siteName} />;
    case 'pricing':
      return <TenantPricingPage page={page} sections={sections} siteName={siteName} />;
    case 'customers':
      return <TenantCustomersPage page={page} sections={sections} siteName={siteName} />;
    case 'about':
      return <TenantAboutPage page={page} sections={sections} siteName={siteName} />;
    default:
      return <ProseFallback html={page.content || ''} />;
  }
}
